export default "__VITE_ASSET__699d0f19__"